/** @typedef {'player' | 'manager' | 'admin'} TrainingRoleId */

export const TRAINING_ROLES = /** @type {const} */ ({
  PLAYER: "player",
  MANAGER: "manager",
  ADMIN: "admin",
});

/** @type {Record<TrainingRoleId, string>} */
export const DEFAULT_ROLE_LABELS = {
  player: "Joueur",
  manager: "Gestionnaire",
  admin: "Administrateur",
};

/**
 * @param {TrainingRoleId} roleId
 * @param {Partial<Record<TrainingRoleId, string>>} [labels]
 */
export function getRoleLabel(roleId, labels = DEFAULT_ROLE_LABELS) {
  return labels[roleId] || roleId;
}
